module.exports = __webpack_public_path__ + "static/img/1740_phase_function_Paper_PointsHejduk_Prediction.91ed7ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1740_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Ov4r
// module chunks = 0